import { PropsWithChildren, useRef, useLayoutEffect, FC, HTMLAttributes } from 'react';

import { useScrollContext } from '@hh.ru/magritte-ui-scrollable-container';

export const ScrollableItem: FC<PropsWithChildren<HTMLAttributes<HTMLDivElement>>> = ({ children, ...props }) => {
    const ref = useRef<HTMLDivElement>(null);
    const { registerItem, removeItem, scrollToItem } = useScrollContext();

    useLayoutEffect(() => {
        registerItem(ref);
        return () => removeItem(ref);
    }, [registerItem, removeItem]);

    return (
        <div ref={ref} onClick={() => scrollToItem(ref)} {...props}>
            {children}
        </div>
    );
};
